import type { FC } from "react";

import { TableHeader } from "@/components/ui/table";

import type { TableProps } from "./types";

const TableHeaderCustom: FC<TableProps> = ({ children }) => {
  return <TableHeader className="bg-gray-50">{children}</TableHeader>;
};

export default TableHeaderCustom;
